export default [
  {
    title: 'FBR Invoice',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'Business Management',
        route: 'fbr-business-management',
        meta: {
          requiresAdmin: true,
        },
      },
    ],
  },
];
